import { html, body } from '@utilities/dom-elements';

const HEADER_HIDDEN_CLASS = 'header--is-hidden';

class BackgroundLight {
  constructor(element) {
    this.element = element;
    this.lightPosOffset = this.element.offsetWidth / 2;

    this.bindEvents();
  }

  bindEvents() {
    body.addEventListener('mousemove', (e) => this.updateLightPosition(e));
  }

  updateLightPosition(e) {
    const x = e.clientX;
    const y = e.clientY;
    const newXPos = x - this.lightPosOffset;
    const newYPos = y - this.lightPosOffset;

    // only let user play with light when header is not in view.
    if (html.classList.contains(HEADER_HIDDEN_CLASS)) {
      this.element.style.transform = `translate3d(${newXPos}px, ${newYPos}px, 0px)`;
    } else {
      this.element.removeAttribute('style');
    }
  }
}
export default BackgroundLight;
